import { flow, Instance, types } from 'mobx-state-tree';
//@ts-ignore
import packageJson from '../../package.json';
//import { ApplicationSettings } from './models/ApplicationSettings';
import { getEnvironment } from './utils/utils';
import { getBaseStore } from './BaseStore';


export const ApplicationStore = types
.model('ApplicationStore', {
  appVersion: packageJson.version,
  mailRedirection: types.maybe(types.string),
  database: types.maybe(types.string),
  transferModuleMode: types.maybe(types.string),
  backendVersion: types.maybe(types.string),
  backendSettings: types.maybe(types.model(
    {
      //Security: packageJson.version,
      Database: types.model({
        InMemoryDatabase: types.boolean,
        ConnectionString: types.string
      }),
      //Mail: Mail,
      TransferModuleMode: types.maybe(types.string),
      PharmamoveModule: types.maybe(types.string),
    }
  )),
})
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const navigate = (url: string, state?: any) => {
      env.history.push(url);
    };

    const replace = (url: string, state?: any) => {
      env.history.replace(url);
    };

    const getMailRedirection = flow(function*() {
      const result = yield apiFetcher.get('system/mailRedirection');
      self.mailRedirection = result;
    });

    const getDatabase = flow(function*() {
      const result = yield apiFetcher.get('system/database');
      self.database = result;
    });

    const getTransferModuleMode = flow(function*() {
      const result = yield apiFetcher.get('system/transferModuleMode');
      self.transferModuleMode = result;
      return result;
    });

    const getBackendVersion = flow(function*() {
      const result = yield apiFetcher.get('system/version');
      self.backendVersion = result;
      return result;
    });

    const getSystemStatus = flow(function*() {
      const result = yield apiFetcher.get('systemstatus');
      // self.backendSettings = result;
      return result;
    });

    const getBackendSettings = flow(function*() {
      const result = yield apiFetcher.get('system/settings');
      // self.backendSettings = result;
      return result;
    });

    return {
      navigate,
      replace,
      getMailRedirection,
      getDatabase,
      getTransferModuleMode,
      getBackendVersion,
      getSystemStatus,
      getBackendSettings,
      afterAttach: flow(function*() {
        yield getMailRedirection();
        yield getBackendVersion();
      }),
    };
  });
